module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNjQwdjQ4MEgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwMWI5YSIgZD0iTTAgMTYyLjU0NGg2NDB2MTYwLjAwM0gweiIvPgogICAgPHBhdGggZmlsbD0iI2U3MDAwMCIgZD0iTTAgLjA0Mmg2NDB2ODIuNUgwek0wIDQwMC4wMDNoNjQwdjgwSDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/th.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/th.svg
// module chunks = 0